import '../assets/NcAssistantButton-CeNrbdrG.css';
import { defineComponent, openBlock, createElementBlock, normalizeClass, createVNode, createSlots, withCtx, createBlock, unref, createElementVNode, renderSlot, createTextVNode, toDisplayString } from "vue";
import { p as mdiCreation } from "./mdi-CpchYUUV.mjs";
import { N as NcAssistantIcon } from "./NcAssistantIcon-DW-HrfQg.mjs";
import { N as NcButton } from "./NcButton-QbPBynlU.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-g8ubWhoz.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAssistantButton",
  props: {
    disabled: { type: Boolean },
    text: { default: "" },
    variant: { default: "secondary" }
  },
  emits: ["click"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{
          [_ctx.$style.assistantButton_disabled]: __props.disabled,
          [_ctx.$style.assistantButton_primary]: __props.variant === "primary"
        }, _ctx.$style.assistantButton])
      }, [
        createVNode(NcButton, {
          class: normalizeClass(_ctx.$style.assistantButton__button),
          disabled: __props.disabled,
          variant: "tertiary",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
        }, createSlots({
          icon: withCtx(() => [
            __props.variant === "primary" ? (openBlock(), createBlock(NcIconSvgWrapper, {
              key: 0,
              class: normalizeClass(_ctx.$style.assistantButton__icon),
              path: unref(mdiCreation)
            }, null, 8, ["class", "path"])) : (openBlock(), createBlock(NcAssistantIcon, { key: 1 }))
          ]),
          _: 2
        }, [
          __props.text || _ctx.$slots.default ? {
            name: "default",
            fn: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(_ctx.$style.assistantButton__text)
              }, [
                renderSlot(_ctx.$slots, "default", {}, () => [
                  createTextVNode(toDisplayString(__props.text), 1)
                ])
              ], 2)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["class", "disabled"])
      ], 2);
    };
  }
});
const assistantButton = "_assistantButton_UUMG0";
const assistantButton_disabled = "_assistantButton_disabled_54C4T";
const assistantButton_primary = "_assistantButton_primary_B08--";
const assistantButton__icon = "_assistantButton__icon_5jSw4";
const assistantButton__text = "_assistantButton__text_A51rL";
const assistantButton__button = "_assistantButton__button_Dh9XH";
const style0 = {
  "material-design-icon": "_material-design-icon_eTNEC",
  assistantButton,
  assistantButton_disabled,
  assistantButton_primary,
  assistantButton__icon,
  assistantButton__text,
  assistantButton__button
};
const cssModules = {
  "$style": style0
};
const NcAssistantButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAssistantButton as N
};
//# sourceMappingURL=NcAssistantButton-BMuKy6Mh.mjs.map
